exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7ece5070] .w-e-toolbar{border:1px solid #dcdfe6;border-left:none}[data-v-7ece5070] .w-e-text-container{height:var(--height);border-top:none;overflow:hidden;padding:30px}[data-v-7ece5070] .w-e-scroll{overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}.main[data-v-7ece5070]{width:var(--width);margin:0 auto}\n", ""]);

// exports
